<div class="wc-page">

  <!-- ── Cabecera ─────────────────────────────────────────── -->
  <div class="wc-header">
    <div class="wc-header__left">
      <div class="wc-header__icon">
        <mat-icon>account_balance_wallet</mat-icon>
      </div>
      <div>
        <h1 class="wc-header__title">Fondo de maniobra</h1>
        <p class="wc-header__sub">Diferencia entre activo y pasivo corriente · Año {{ yearSelected }}</p>
      </div>
    </div>
  </div>

  <!-- ── Toggle ────────────────────────────────────────────── -->
  <div class="wc-toggle-card">
    <mat-icon>business</mat-icon>
    <span class="wc-toggle-label">Todas las actividades</span>
    <mat-slide-toggle [(ngModel)]="showGlobal" (change)="getData()" color="primary"></mat-slide-toggle>
  </div>

  <!-- ── Loading ───────────────────────────────────────────── -->
  <div class="wc-loading" *ngIf="!resumeloading">
    <div class="wc-loading__icon-wrap"><mat-icon>account_balance_wallet</mat-icon></div>
    <div class="wc-loading__dots"><span></span><span></span><span></span></div>
    <p class="wc-loading__text">Calculando fondo de maniobra…</p>
  </div>

  <!-- ── KPI Cards ─────────────────────────────────────────── -->
  <div class="wc-kpi-grid" *ngIf="resumeloading && summaryResult">

    <!-- Activo corriente -->
    <div class="wc-kpi wc-kpi--blue">
      <div class="wc-kpi__icon-row">
        <div class="wc-kpi__icon"><mat-icon>trending_up</mat-icon></div>
        <span class="wc-kpi__label">Activo corriente</span>
      </div>
      <div class="wc-kpi__value">
        {{ summaryResult.currentAssets | currency:'EUR':'symbol':'1.2-2':'es' }}
      </div>
      <span class="wc-kpi__year">Año {{ yearSelected }}</span>
    </div>

    <!-- Pasivo corriente -->
    <div class="wc-kpi wc-kpi--amber">
      <div class="wc-kpi__icon-row">
        <div class="wc-kpi__icon"><mat-icon>trending_down</mat-icon></div>
        <span class="wc-kpi__label">Pasivo corriente</span>
      </div>
      <div class="wc-kpi__value">
        {{ summaryResult.currentLiabilities | currency:'EUR':'symbol':'1.2-2':'es' }}
      </div>
      <span class="wc-kpi__year">Año {{ yearSelected }}</span>
    </div>

    <!-- Fondo de maniobra -->
    <div class="wc-kpi wc-kpi--result"
         [style.--wc-kpi-result-color]="summaryResult.workingCapital >= 0 ? '#15803d' : '#dc2626'">
      <div class="wc-kpi__icon-row">
        <div class="wc-kpi__icon"><mat-icon>account_balance</mat-icon></div>
        <span class="wc-kpi__label">Fondo de maniobra</span>
      </div>
      <div class="wc-kpi__value">
        {{ summaryResult.workingCapital | currency:'EUR':'symbol':'1.2-2':'es' }}
      </div>
      <span class="wc-kpi__pct"
            [class.wc-kpi__pct--pos]="summaryResult.workingCapital >= 0"
            [class.wc-kpi__pct--neg]="summaryResult.workingCapital < 0">
        <mat-icon style="font-size:14px;width:14px;height:14px">
          {{ summaryResult.workingCapital >= 0 ? 'arrow_upward' : 'arrow_downward' }}
        </mat-icon>
        {{ getPositivePercentage(summaryResult.workingCapital, summaryResult.currentAssets) | percent:'1.0-1' }}
        sobre activo corriente
      </span>
      <span class="wc-kpi__year">Año {{ yearSelected }}</span>
    </div>

  </div>

</div>
